import { render, staticRenderFns } from "./PortalMultipagosExpress.vue?vue&type=template&id=15cce7c8&"
import script from "./PortalMultipagosExpress.vue?vue&type=script&lang=js&"
export * from "./PortalMultipagosExpress.vue?vue&type=script&lang=js&"
import style0 from "./PortalMultipagosExpress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports